import { Link } from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router';
import { getVideoNotificationAdPath } from './videoNotifications';
import { TiktokVideoNotificationItem } from './types';

interface VideoNotificationReadyToastProps {
  item: TiktokVideoNotificationItem;
  onHereClick: () => void;
  children: ReactNode;
}

export const VideoNotificationReadyToast: FunctionComponent<VideoNotificationReadyToastProps> = ({
  item,
  onHereClick,
  children,
}) => {
  const path = getVideoNotificationAdPath(item);

  return (
    <Link
      component={RouterLink}
      to={path}
      color="inherit"
      underline="always"
      onClick={onHereClick}
      data-testid={`video-notification-toast-link-${item.id}`}
    >
      {children}
    </Link>
  );
};
